import { CalculateCost } from '../contracts';
import { ICalculateCostRequest, ICalculateCostResponse } from '@lib/types';
import { CartProductCode } from '@ace-clublabs/common-membership-api-types';
export const CalculateCostStub: CalculateCost = async (_: ICalculateCostRequest) => {
  return calculateCostStubData;
};

const calculateCostStubData: ICalculateCostResponse = {
  priceCart: {
    savings: 0,
    salesTax: 0,
    total: 42,
    items: [
      {
        id: 'SERVICE_FEE',
        code: CartProductCode.SERVICELEVEL,
        description: 'Renewal discount',
        price: 20,
        discount: 5,
      },
      {
        id: 'RV_COST',
        code: CartProductCode.RV,
        description: 'Roadside for RV/motorcycle',
        price: 42,
        discount: 12,
      },
      {
        id: 'FAMILY_COST',
        code: CartProductCode.FAMILYCOST,
        description: 'Family upgrade fee',
        price: 17,
        discount: 17,
      },
      {
        id: 'AUTOPAY_DISCOUNT',
        code: CartProductCode.AUTOPAY_DISCOUNT,
        description: 'Autopay discount',
        price: 5,
        discount: 5,
      },
      {
        id: 'ASSOCIATE_DISCOUNT',
        code: CartProductCode.ASSOCIATE,
        description: 'Associate discount',
        price: 5,
        discount: 5,
      },
      {
        id: 'ASSOCIATE_DISCOUNT',
        code: CartProductCode.ASSOCIATE,
        description: 'Associate discount',
        price: 5,
        discount: 5,
      },
      {
        id: 'ASSOCIATE_DISCOUNT',
        code: CartProductCode.ASSOCIATE,
        description: 'Associate discount',
        price: 5,
        discount: 5,
      },
      {
        id: 'ASSOCIATE_DISCOUNT',
        code: CartProductCode.ASSOCIATE,
        description: 'Associate discount',
        price: 5,
        discount: 2,
      },
      {
        id: 'ASSOCIATE_DISCOUNT',
        code: CartProductCode.ASSOCIATE,
        description: 'Associate discount',
        price: 5,
        discount: 2,
      },
    ],
  },
  prospectiveCosts: {
    classic: {
      memberRoles: {
        AD: 20,
      },
      products: {
        RV: 10,
      },
      discounts: {
        autopay: 4,
      },
    },
    plus: {
      memberRoles: {
        AD: 20,
      },
      products: {
        RV: 10,
      },
      discounts: {
        autopay: 4,
      },
    },
    premier: {
      memberRoles: {
        AD: 20,
      },
      products: {
        RV: 10,
      },
      discounts: {
        autopay: 4,
      },
    },
  },
  additionalDiscounts: [],
};
